var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import BS_Carousel from 'bootstrap/js/dist/carousel';
export class Carousel extends Component {
    constructor() {
        super('Carousel', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.carousel').each((carousel) => {
                new BS_Carousel(carousel.get(0));
            });
            let timout = null;
            $(window).on('resize', () => {
                clearTimeout(timout);
                timout = window.setTimeout(() => {
                    this.setCarouselHeight();
                }, 200);
            });
            for (let i = 0; i < 3; i++) {
                setTimeout(() => {
                    this.setCarouselHeight();
                }, 200 + (i * 500));
            }
            this.setCarouselHeight();
            this.success();
        });
    }
    setCarouselHeight() {
        $('.carousel').each((carousel) => {
            carousel.find('.carousel-item').addClass('active');
            carousel.find('.carousel-item, .carousel-box').removeAttr('style');
            // Set boxes height to the height of the tallest box
            let height = carousel.find('.carousel-box').width() / 0.75;
            carousel.find('.carousel-box').each((item) => {
                if (item.height() > height)
                    height = item.height();
            });
            carousel.find('.carousel-box').css('height', height);
            // Set items height to the height of the tallest item
            height = 0;
            carousel.find('.carousel-item').each((item) => {
                if (item.height() > height)
                    height = item.height();
            });
            carousel.find('.carousel-item').css('height', height);
            // Restore active item
            carousel.find('.carousel-item').removeClass('active').first().addClass('active');
        });
    }
}
